// extracted by mini-css-extract-plugin
export default {"image":"image--_BBnu","videoPlayer":"videoPlayer--D1OHV"};